(function () {
  const originalFetch = window.fetch;

  window.fetch = async function (url, options) {
    try {
      if (
        typeof url === 'string' &&
        url.includes('/cart/add')
      ) {
        const nameInput = document.getElementById('penNameInput');
        const fontSelect = document.getElementById('penFontSelect');
        const positionSelect = document.getElementById('engravingPosition');

        if (nameInput && fontSelect && positionSelect && nameInput.value.trim()) {
          if (options && options.body instanceof FormData) {
            options.body.append('properties[Engraved Name]', nameInput.value);
            options.body.append('properties[Engraving Font]', fontSelect.value);
            options.body.append('properties[Engraving Position]', positionSelect.value);
          }
          else if (options && typeof options.body === 'string') {
            // Magic Buy Now + side cart
            const payload = JSON.parse(options.body);
            payload.items[0].properties = {
              'Engraved Name': nameInput.value,
              'Engraving Font': fontSelect.value,
              'Engraving Position': positionSelect.value
            };
            options.body = JSON.stringify(payload);
          }
        }
      }
    } catch (e) {}

    return originalFetch.apply(this, arguments);
  };
})();
